import {isPlayerFaction} from '../../factions/isPlayerFaction';
import {FACTIONS} from '../../../constants/factions';

/**
 * Отряды игрока не голодают НИКОГДА — ни от нехватки пайков, ни вдали от ферм.
 *
 * Пока это только инсектоиды: каждый их отряд снабжается сам, с мок-фермы
 * фракции (FACTION_INSECTOIDS_MOCK_FARM_HEX_KEY, см. executePhaseAutoActions),
 * поэтому нехватка настоящих ферм означает для них лишь меньший рост, а не
 * усыхание отрядов, и пути снабжения им не нужны вовсе.
 *
 * Общая точка правды для всех предупреждений о снабжении: подсказки после
 * найма («кто-то будет голодать», recruitNewUnitOnBarracks) и подсветки пути
 * до ближайшей фермы (GameScene.showSupplyOutOfRangeHintIfNeeded) — обе
 * обязаны молчать у одних и тех же игроков
 *
 * @param {Object} player
 * @returns {boolean}
 */
export const checkIfPlayerUnitsNeverStarve = (player) => (
  isPlayerFaction(player || {}, FACTIONS.INSECTOIDS)
);
